module.exports = __webpack_public_path__ + "media/images/page/photo_s1-4edf1df7222310c799ffcab502053110.jpg";